import UserEvent from './UserEvent';

export default class UserSignedIn extends UserEvent {
}


// WEBPACK FOOTER //
// ./code/project/modules/users/domain/aggregates/user/events/UserSignedIn.ts